











































































































































































import {  Component, Watch } from 'vue-property-decorator';
import Api, { BotFiltersApi } from './api';

import { pick } from 'lodash';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component
export default class BotFilters extends PlanLimitsMixin {
  api: BotFiltersApi = Api;

  domains: any[] = [];
  rows: any[] = [];
  error: boolean = false;
  rowsOnPage: number = 10;
  loading: boolean = false;

  pagination: any = {
    rowsPerPage: this.rowsOnPage
  };

  form: any = {};

  get botFiltersText() {
    return `<span>${this.t('Set up filters to manage the bot traffic in your campaigns according to the conditions selected in Bot Detection Rules section on the right.')}</span>
    <span>${this.t('Read more in our {0}.', [`<a href='https://docs.bemob.com/${this.$i18n.locale}/bot-filters-types' target='_blank'>${this.t('guide')}</a>`])}</span>`
  }

  get headers() {
    return [
      {
        text: this.t('Name'),
        align: 'left',
        value: 'name',
        sortable: false
      },
      {
        text: this.t('Using Conditions'),
        align: 'center',
        value: 'conditions',
        sortable: false
      },
      {
        text: ' ',
        align: 'right',
        sortable: false,
        value: 'actions'
      }
    ];
  }

  chipColor({key,value}){
    switch(key) {
      case 'brand':
      case 'connectType':
      case 'browser':
      case 'country':
      case 'state':
      case 'city':
      case 'custom1':
      case 'custom2':
      case 'custom3':
      case 'custom4':
      case 'custom5':
      case 'custom6':
      case 'custom7':
      case 'custom8':
      case 'custom9':
      case 'custom10':
      case 'ip':
      case 'isp':
      case 'os':
      case 'dayOfWeek':
      case 'timeOfDay':
      case 'mobileCarrier':
      case 'language':
      case 'deviceType':
        return value.predicate === 'NOT_EQUALS' ? this.$colors.red : this.$colors.green;
      case 'userAgent':
      case 'referrerDomain':
      case 'referrer':
        return value.predicate === 'NOT_CONTAINS' ? this.$colors.red : this.$colors.green;
      case 'visitCountryMatch':
        return value.values === 'IS_NOT_MATCHING' ? this.$colors.red : this.$colors.green;
      case 'ipBlacklisted':
        return value.values === 'IS_NOT_IP_BLACKLISTED' ? this.$colors.red : this.$colors.green;
      case 'ipWithFrequentCampaignEvents':
        return value.values === 'IP_NOT_WITH_FREQUENT_CAMPAIGN_EVENTS' ? this.$colors.red : this.$colors.green;
      case 'ipWithFrequentEvents':
        return value.values === 'IP_NOT_WITH_FREQUENT_EVENTS' ? this.$colors.red : this.$colors.green;
      case 'ipDataCenter':
        return value.values === 'IS_NOT_IP_DATACENTER' ? this.$colors.red : this.$colors.green;
      case 'webViewMark':
        return value.values === 'IS_NOT_WEB_VIEW' ? this.$colors.red : this.$colors.green;
      case 'crawler':
        return value.values === 'IS_NOT_CRAWLER' ? this.$colors.red : this.$colors.green;
      case 'proxy':
        return value.values === 'IS_NOT_PROXY' ? this.$colors.red : this.$colors.green;
      case 'customToken':
      case 'queryHeader':
        const containsEqual = value.find(({ predicate })=>predicate==='EQUALS' || predicate==='CONTAINS')
        const containsNotEqual = value.find(({ predicate })=>predicate==='NOT_EQUALS' || predicate==='NOT_CONTAINS')
        if(containsEqual && !containsNotEqual) return this.$colors.green;
        if(!containsEqual && containsNotEqual) return this.$colors.red;
        return this.$colors.graphite
      case 'timezone':
        return this.$colors.graphite
      case 'externalId':
        return value.values === 'IS_NOT_EMPTY' ? this.$colors.red : this.$colors.green;
    }
    
    return this.$colors.graphite
  }

  rulesText: any = {
    brand: this.t('Brand and model'),
    connectType: this.t('Connection type'),
    customToken: this.t('Custom token'),
    browser: this.t('Browser and version'),
    country: this.t('Country'),
    state: this.t('State / region'),
    custom1: this.t('Custom 1'),
    custom2: this.t('Custom 2'),
    custom3: this.t('Custom 3'),
    custom4: this.t('Custom 4'),
    custom5: this.t('Custom 5'),
    custom6: this.t('Custom 6'),
    custom7: this.t('Custom 7'),
    custom8: this.t('Custom 8'),
    custom9: this.t('Custom 9'),
    custom10: this.t('Custom 10'),
    ip: this.t('IP'),
    isp: this.t('ISP'),
    dayOfWeek: this.t('Day of week'),
    timezone: this.t('Timezone'),
    language: this.t('Language'),
    deviceType: this.t('Device type'),
    mobileCarrier: this.t('Mobile carrier'),
    externalId: this.t('External ID'),
    referrer: this.t('Referrer'),
    os: this.t('OS and version'),
    userAgent: this.t('User agent'),
    city: this.t('City'),
    timeOfDay: this.t('Time of day'),
    queryHeader: this.t('Query header'),
    webViewMark: this.t('WebView'),
    referrerDomain: this.t('Referrer Domain'),
    crawler: this.t('Crawler'),
    proxy: this.t('Proxy'),
    ipDataCenter: this.t('IPs From Data Centers'),
    ipBlacklisted: this.t('IPs From Blacklists'),
    ipWithFrequentCampaignEvents: this.t('Frequent Campaign Events'),
    ipWithFrequentEvents: this.t('Frequent Events'),
    visitCountryMatch: this.t('Campaign and Visit Geo'),
  };
 
  get errorMessages() {
    return this.error && this.enabled
      ? this.t('Bot redirect URL should be a valid URL')
      : null;
  }

  openAddBotDetectionRules(id: string) {
    this.bus.emit('open-dialog', { name: 'AddBotDetectionRules', data: { id } });
  }

  deleteRow(id: string) {
    this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
      message: this.t('All selected items will be deleted permanently if you press OK.'),
      onConfirm: () => {
        this.api.delete(id)
          .then(() => this.api.get())
          .then((data: any) => this.rows = data)
      },
    }})
  }

  load(): any {
    const botRules: Promise<any> = this.api.get();

    return Promise.all([botRules])
  }

  mounted() {
    this.$store.commit('loading', true);
    this.loading = true;
    this.load()
      .then(() => {
        this.fillForm(this.$store.state.user);
      })
      .finally(() => {
        this.$store.commit('loading', false);
        this.loading = false;
      });
  }

  fillForm(source: any){
    this.form = pick(source, [
      'enableBotFilters',
      'botFiltersType',
      'botFiltersRedirectUrl'
    ]);
  }

  addBotDetectionRules() {
    this.bus.emit('open-dialog', { name: 'AddBotDetectionRules' });
  }

  get enabled() {
    return this.form.botFiltersType === 'redirect';
  }

  submit() {
    this.api.loading = true;
    this.loading = true;

    return this.api.put(this.form).then((res: any) => {
      const user = {
        ...res,
        enableBotFilters: !!res.enableBotFilters,
      }

      this.$store.commit('updateUser', user);
      this.error = false;
      this.bus.emit('toast-success', this.t('Bot filter has been successfully saved'));

      this.$mixpanel?.track('settings_bot_filters', {
        'bot_filters_type': this.form.botFiltersType,
        ...(this.form.botFiltersType === 'redirect'&&{'bot_filters_redirect_url': this.form.botFiltersRedirectUrl})
      });
    })
    .catch((e: any) => {
      if (e.response.data.message === 'VALIDATION_FAILED') {
        this.error = true;
      }
    })
    .finally(() => {
      this.loading = false;
      this.api.loading = false;
    }); 
  }

  @Watch('$store.state.user')
  dataReceived(data: any) {
    this.fillForm(data);
  }

  @Watch('api.data')
  dataBotRules(data: any) {
    this.rows = data;
  }
  
  get showPlanLimitsWarning_botFilterEnabled_left(){
    return this.$store.state.user.enableBotFilters && this.hasPlanLimitsRestriction('botFiltersAccess')
  }
  
  get showPlanLimitsWarning_botFilterEnabled_right(){
    return this.hasPlanLimitsRestriction('botFiltersAccess')
  }
}
